import React from "react";
import logo from "../../images/logo.png";
import { Link } from "react-router-dom";
import TabHover from "../pages/Company/TabHover";
import ResourceHover from "../ResourceHover";
import { FiMenu } from "react-icons/fi";
import { CgCloseO } from "react-icons/cg";
import "./Header.css";
const Header = () => {
  return (
    <nav>
      <div className="wrapper">
        <div className="logo">
          <Link to={"/"}>
            <img src={logo} alt="" className="w-36 " />
          </Link>
        </div>
        <input type="radio" name="slider" id="menu-btn" />
        <input type="radio" name="slider" id="close-btn" />
        <ul className="nav-links">
          <label htmlFor="close-btn" className="mobile-btn close-btn">
            <CgCloseO />
          </label>

          <div className="mt-[-30px]">
            <Link to={"/"}>
              <img src={logo} alt="" className="w-40 mobile-item ml-2" />
            </Link>
          </div>

          <li>
            <a href="#" className="font-semibold text-accent ">
              Solutions
            </a>{" "}
          </li>
          <li>
            <a href="#" className="font-semibold text-accent ">
              Integration
            </a>{" "}
          </li>
          <li>
            <a href="#" className="font-semibold text-accent ">
              Developers
            </a>{" "}
          </li>

          <li>
            <span className=" text-accent hover:text-primary cursor-pointer desktop-item text-[18px] px-[15px]">
              Resources
            </span>
            <input type="checkbox" id="showMega" />
            <div className="mega-box desktop-item">
              <ResourceHover />
            </div>
            <div className="mobile-item dropdown dropdown-hover">
              <label
                tabIndex="0"
                className="mobile-item hover:text-primary text-accent pl-[0px!important]"
              >
                Resources
              </label>
              <ul
                tabIndex="0"
                className="dropdown-content  menu p-2 bg-base-100 rounded-box w-52 mobile-item shadow-2xl"
              >
                <li>
                  <Link to={"/blog"} className="font-semibold text-accent ">
                    Blogs
                  </Link>
                </li>
                <li>
                  <Link to={"/question"} className="font-semibold text-accent ">
                    FAQs
                  </Link>
                </li>
              </ul>
            </div>
          </li>
          <li>
            <span className=" text-accent hover:text-primary cursor-pointer desktop-item text-[18px] px-[15px]">
              Company
            </span>
            <input type="checkbox" id="showMega" />
            <div className="mega-box desktop-item">
              <TabHover />
            </div>
            <div className="mobile-item dropdown dropdown-hover">
              <label
                tabIndex="0"
                className="mobile-item hover:text-primary text-accent pl-[0px!important]"
              >
                Company
              </label>
              <ul
                tabIndex="0"
                className="dropdown-content  menu p-2 bg-base-100 rounded-box w-52 mobile-item shadow-2xl"
              >
                <li>
                  <Link to={"/about"} className="font-semibold text-accent ">
                    About Us
                  </Link>
                </li>
                <li>
                  <Link to={"/contact"} className="font-semibold text-accent ">
                    Contact Us
                  </Link>
                </li>
                <li>
                  <Link to={"/about"} className="font-semibold text-accent ">
                    Careers
                  </Link>
                </li>
                <li>
                  <Link to={"/contact"} className="font-semibold text-accent ">
                    Legal
                  </Link>
                </li>
              </ul>
            </div>
          </li>
          <li>
            <a href="#" className="font-semibold text-accent ">
              Plans
            </a>{" "}
          </li>

          <li className="mobile-item">
            <Link
              to="/login"
              className="bg-white border border-gray-200 rounded-lg py-2 px-5 font-semibold hover:bg-slate-600 hover:text-white text-center"
            >
              Login
            </Link>{" "}
          </li>
          <li className="mobile-item">
            <Link
              to="/create"
              className="bg-primary hover:bg-green-800 text-white border rounded-lg py-2 px-5 font-semibold  text-center"
            >
              SignUp
            </Link>{" "}
          </li>
        </ul>
        <div className="desktop-btn space-x-2 duration-300">
          <Link
            to="/login"
            className="bg-white border border-gray-200 rounded-lg py-2 px-5 font-semibold hover:bg-slate-600 hover:text-white"
          >
            LogIn
          </Link>
          <Link
            to="/create"
            className="bg-primary hover:bg-green-800 text-white border rounded-lg py-2 px-5 font-semibold "
          >
            SignUp
          </Link>
        </div>
        <label htmlFor="menu-btn" className="mobile-btn menu-btn">
          <FiMenu className="text-2xl" />
        </label>
      </div>
    </nav>
  );
};

export default Header;
